module.exports = __webpack_public_path__ + "static/img/vf_game_2024.fa1252a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_grande/vf_game_2024.png
// module id = S3iV
// module chunks = 1